import { cn } from '../../css/className/className';

import { SkinSize } from './generated/types';

import './generated/getSizeSkin.css';

const cls = cn('SizeSkin');

/**
 * Вспомогательная функция, которая навешивает размерные скины на нужный элемент.
 * Создает переменные `dc-size-current-skin-*`, которые нужно использовать в css компонентов
 * @internal
 * @param size название размерного скина
 * @returns className, который нужно передать на элемент
 */
export function getSizeSkin(size: SkinSize) {
    return cls({ size });
}
